import React, { useState } from "react";
import { Avatar, Button, Modal, Result } from "antd";
import { HeartTwoTone, SmileOutlined, UserOutlined } from "@ant-design/icons";
import { useMyContext } from "../../context/MyContext";

const Popup = ({ open, setOpen }) => {
  const { user, setShowTermsModal, setWelcomePopupShown } = useMyContext();

  const handleTermsClick = (e) => {
    e.preventDefault();
    setOpen(false);
    setShowTermsModal(true); // Open the TermsModal
  };

  const handleOk = () => {
    setOpen(false);
    setWelcomePopupShown(true); // Track that we've shown and closed the welcome popup
  };

  const handleCancel = () => {
    setOpen(false);
    setWelcomePopupShown(true); // Track that we've shown and closed the welcome popup
  };

  return (
    <>
      <Modal
        title=""
        open={open}
        onOk={handleOk}
        footer={false}
        onCancel={handleCancel}
      >
        <Result
          icon={
            <Avatar
              style={{
                backgroundColor: "#87d068",
              }}
              size={70}
              icon={<UserOutlined />}
            />
          }
          status="success"
          title={user?.name}
          subTitle={user?.email}
        />
        <h2 className="text-xl font-bold text-center pb-2 -mt-5">Welcome Back To One Union Solutions!</h2>

        <p className="text-sm  text-center py-2 text-gray mb-4">You have successfully logged in.</p>


        <div className="flex flex-wrap gap-5 items-center w-full justify-between">
          <button
            onClick={handleCancel}
            className="py-3 w-full btnBg rounded-xl">Continue</button>

          {/* <button
            onClick={handleCancel}
            className="py-3 w-2/5 bg-green-500 rounded-xl text-white">2 factor Authentication</button> */}
        </div>

        {user?.role === "user" && (
          <div className="text-center mt-4">
            <button
              onClick={handleTermsClick}
              className="text-blue-600 hover:text-blue-800 text-sm underline cursor-pointer border-none bg-transparent"
            >
              Terms and Conditions
            </button>
          </div>
        )}
      </Modal>
    </>
  );
};
export default Popup;
